import e from"./RatingMenu.vue_vue&type=script&lang.js";import{render as t}from"./RatingMenu.vue_vue&type=template&id=9254de68&lang.js";e.render=t,e.__file="src/components/RatingMenu.vue";export default e;
//# sourceMappingURL=RatingMenu.vue.js.map
